import React from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { routes } from '../MainPage'
import { useDispatch, useSelector } from 'react-redux'
import PageBanner from '../Components/Other/PageBanner'
import moment from 'moment';
import { CommonApiFun } from '../Redux/Action/index'

function AllReview(props) {
    var dispatch = useDispatch()
    let { name } = useParams();
    let navigate = useNavigate();
    let location = useLocation()
    const [isLoading, setIsloading] = useState(true)
    var reviewArr = useSelector((state) => state.reviewArr)
    useEffect(() => {
        var data = { action: "patient_review", view: true }
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
            setIsloading(false)
            dispatch({ type: 'REVIEW_DATA', payload: res.data })

        }).catch((e) => {
            setIsloading(false)
        })
    }, [])
    return (
        <PageWrapper className={"blog-page"}>
            <div className="pageWrapper">
                <PageBanner pageName={"All Reviews"}></PageBanner>
                <div className="MainContent">
                    <div className="container">
                        <div className="review_list">
                            <div className="review_box">
                                {(reviewArr.length == 0 && isLoading) ? <div className='loader-box'><div className="loader"></div></div>
                                    : reviewArr.length == 0 &&
                                    <div class="not_found">
                                        <span><img src={require('../img/emptyData.png')} /></span><p>No review Found</p>
                                    </div>}
                                {reviewArr.map((item, index) => {

                                    const { name, profile_image, rate, review_description } = item
                                    return (<div className="review_item">
                                        <div className="review_i">
                                            <img src={profile_image != "" ? profile_image : require('../img/evnetPlaceHolder.png')} />
                                            {item.profile_image == "" && <span className='review_char'>{name.charAt(0)}</span>}
                                            <span>
                                                <h4>{name}</h4>
                                                <ul>
                                                    <div className="review_star">
                                                        <i className="fas fa-star" style={{ color: rate >= 1 ? '#fdc973' : 'gray' }} />
                                                        <i className="fas fa-star" style={{ color: rate >= 2 ? '#fdc973' : 'gray' }} />
                                                        <i className="fas fa-star" style={{ color: rate >= 3 ? '#fdc973' : 'gray' }} />
                                                        <i className="fas fa-star" style={{ color: rate >= 4 ? '#fdc973' : 'gray' }} />
                                                        <i className="fas fa-star" style={{ color: rate >= 5 ? '#fdc973' : 'gray' }} />

                                                    </div>
                                                </ul>
                                            </span>
                                        </div>
                                        <div className="review_txt">
                                            <p>
                                                {review_description}
                                            </p>
                                        </div>
                                    </div>)
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
}

export default AllReview;